module.exports = __webpack_public_path__ + "img/updateImg3.17b1a530.png";